import {Component, input} from '@angular/core';

@Component({
  selector: 'app-icon-checked-square',
  imports: [],
  templateUrl: './icon-checked-square.component.html',
})
export class IconCheckedSquareComponent {
  color = input('currentColor');
  size = input('24');
}
